

























import { Component, Prop, Vue } from "vue-property-decorator";
import { ClientSetupLicenceKey } from "@/data/models/ClientSetup";
import { ClientSetupDraft, MAX_LICENCE_COUNT, licenceCount, neededLicences } from "@/utils/ClientSetupDraft";
import { LICENCE_LABEL_KEYS } from "@/utils/ClientSetupSummary";
import { formatNumber } from "@/utils/Utils";

@Component
export default class SetupLicencesStep extends Vue {
  @Prop({ required: true }) draft!: ClientSetupDraft;

  readonly labelKeys = LICENCE_LABEL_KEYS;
  readonly maxCount = MAX_LICENCE_COUNT;

  get licences(): ClientSetupLicenceKey[] {
    return neededLicences(this.draft.products);
  }

  errorOf(key: ClientSetupLicenceKey): string {
    return licenceCount(this.draft.licences[key]) === null
      ? this.$t("admin.clients.setup.licences.invalid", [formatNumber(MAX_LICENCE_COUNT)]).toString()
      : "";
  }
}
